import React from 'react';

export const About = () => {
  return (
    <section id="about" className="py-20" style={{ backgroundColor: '#f5e9d0' }}>
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2
              className="text-4xl md:text-5xl font-bold mb-6"
              style={{ 
                color: '#5e3a1c',
                fontFamily: 'Georgia, serif'
              }}
            >
              Rooted in Elma, Washington
            </h2>
            <div className="space-y-4" style={{ color: '#8b5c2f' }}>
              <p className="text-lg">
                Mudbutt Brew was born from a deep respect for nature's healing power and a 
                passion for artisanal craftsmanship. In the heart of Elma, Washington, we've 
                created a collection of herbal brews that honor traditional apothecary methods 
                while embracing bold, memorable flavors.
              </p>
              <p className="text-lg">
                Our name might raise eyebrows, but that's exactly the point. We believe great 
                brews should be honest, unapologetic, and rooted in authenticity. Each blend 
                is carefully crafted using hand-selected ingredients from renowned herbal regions 
                around the world - botanicals, berries, and herbs chosen for their exceptional 
                quality and potency.
              </p>
              <p className="text-lg">
                From the mortar and pestle to your cup, every step is guided by tradition, 
                quality, and a commitment to sustainability. We're not just brewing beverages; 
                we're cultivating an experience that connects you to the land, the craft, and 
                the bold spirit of Mudbutt Brew.
              </p>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative h-[500px] rounded-lg overflow-hidden shadow-2xl border-4" style={{ borderColor: '#c2a357' }}>
              <img
                src="https://images.unsplash.com/photo-1760884993296-5d3e0647396e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxwZWFjZWZ1bCUyMHRlYSUyMHRpbWUlMjB0ZXJyYWNlJTIwZ3JlZW4lMjBjb3VudHJ5c2lkZXxlbnwwfHx8fDE3NzMxODY1NDV8MA&ixlib=rb-4.1.0&q=85"
                alt="Tea terrace with peaceful plantation view"
                className="w-full h-full object-cover"
              />
              <div
                className="absolute inset-0"
                style={{
                  background: 'linear-gradient(to top, rgba(94, 58, 28, 0.3), transparent)'
                }}
              />
            </div>
            <div
              className="absolute -bottom-6 -left-6 w-32 h-32 rounded-full blur-3xl opacity-50"
              style={{ backgroundColor: '#8b5c2f' }}
            />
            <div
              className="absolute -top-6 -right-6 w-40 h-40 rounded-full blur-3xl opacity-30"
              style={{ backgroundColor: '#c2a357' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
